export default (params) => ({
  trigger: {
    name: 'product_information.select_more_product_information',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_more',
      params: {
        sub_feature: null,
      },
    },
  },
});
